import styled from 'styled-components';

export const LegendToggleWrapper = styled.div`
  position: absolute;
  right: 1.5rem;
  bottom: 0.5rem;
  z-index: 2;
  pointer-events: none;

  button {
    pointer-events: auto;
  }
`;

export const LegendScrollArea = styled.div<{
  $isScrolledToTop: boolean;
  $isScrolledToBottom: boolean;
  $enableScroll: boolean;
}>`
  height: 100%;
  overflow-y: ${({ $enableScroll }) => ($enableScroll ? 'auto' : 'hidden')};
  font-size: calc(14px * var(--floating-card-scale, 1));
  line-height: 1.4;

  ${({ $isScrolledToTop, theme }) =>
    !$isScrolledToTop &&
    `
      -webkit-box-shadow: inset 0px 5px 5px -3px ${theme.lightShadow};
      -moz-box-shadow: inset 0px 5px 5px -3px ${theme.lightShadow};
      box-shadow: inset 0px 5px 5px -3px ${theme.lightShadow};
    `}

  ${({ $isScrolledToBottom, theme }) =>
    !$isScrolledToBottom &&
    `
      -webkit-box-shadow: inset 0px -5px 5px -3px ${theme.lightShadow};
      -moz-box-shadow: inset 0px -5px 5px -3px ${theme.lightShadow};
      box-shadow: inset 0px -5px 5px -3px ${theme.lightShadow};
    `}

  ul {
    color: ${({ theme }) => theme.headerColor} !important;
    list-style-type: none;
    margin: 0;
    padding: calc(1rem * var(--floating-card-scale, 1));

    li {
      display: flex;
      align-items: center;
      min-height: calc(28px * var(--floating-card-scale, 1));
    }

    span {
      margin-left: calc(0.5rem * var(--floating-card-scale, 1));
    }
  }
`;

export const LegendSymbol = styled.svg`
  flex-shrink: 0;
  width: calc(20px * var(--floating-card-scale, 1));
  height: calc(20px * var(--floating-card-scale, 1));
  margin-right: calc(0.25rem * var(--floating-card-scale, 1));
`;

export const LegendContent = styled.div`
  width: 100%;
`;

export const DamageCountSpan = styled.span`
  color: ${({ theme }) => theme.secondaryTextColor};
  margin-left: 5px !important;
`;
